import { FormattedMessage, useIntl } from 'react-intl';

import { useStyles } from './cookie-policy.styles';
import { ContentWrapper } from '../../../common/content-wrapper';
import { GeneralCookieSection, AppendixCookieSection } from './cooke-policy-sections';
import { Page } from '../page/page';

export const CookiePolicy = (): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Page
      title={intl.formatMessage({ id: 'cookiePolicyPage.title' })}
      description={intl.formatMessage({ id: 'cookiePolicyPage.description' })}
    >
      <div className={classes.root}>
        <ContentWrapper>
          <h1
            data-testid="cookie-title"
            className={classes.heading}
          >
            <FormattedMessage id="cookiePolicy.title" />
          </h1>
          <GeneralCookieSection />
          <AppendixCookieSection />
        </ContentWrapper>
      </div>
    </Page>
  );
};
